module.exports = __webpack_public_path__ + "/bundle/asset/revision1-612405fde4f68282fa381cfc9c66c5cd.png";